import { FormattedMessage, useIntl } from 'react-intl';

import * as SupplierConditionsActions from '../../store/supplier-conditions-actions';
import { TermRequestValue } from '../../api/models/term-request-value';
import { TermsBaseModal } from './terms-base-modal';
import { supplierConditionsDeliveryTermsSelector } from '../../store/supplier-conditions-selectors';
import { useAppSelector } from '../../../../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../../../../store/use-thunk-dispatch';

export interface DeliveryTermsModalProps {
    isVisible: boolean;
    onClose: () => void;
}

export const DeliveryTermsModal = (props: DeliveryTermsModalProps) => {
    const intl = useIntl();
    const dispatch = useThunkDispatch();
    const deliveryTerms = useAppSelector(supplierConditionsDeliveryTermsSelector);

    if (!props.isVisible) {
        return null;
    }

    const handleSubmit = (terms: TermRequestValue[]) => {
        dispatch(SupplierConditionsActions.updateSupplierDeliveryTerms(terms));
        props.onClose();
    };

    return (
        <TermsBaseModal
            terms={deliveryTerms}
            title={<FormattedMessage id="app.contactsAndOrganizations.detail.deliveryTermModal" />}
            inputPlaceholder={intl.formatMessage({
                id: 'app.contactsAndOrganizations.detail.enterDeliveryTerm',
            })}
            newTermTitle={<FormattedMessage id="app.contactsAndOrganizations.detail.addDeliveryTerm" />}
            onClose={props.onClose}
            onSubmit={handleSubmit}
        />
    );
};
